import moment from 'moment';
let utils = 
{
    date_from_sql_to_bookjoy_format(date) {
        return moment(String(date)).format('dddd MMM D, YYYY');
    },
    
    date_from_bookjoy_format_to_sql(date) {
        return moment(String(date)).format('YYYY-MM-DD');
    },

    time_from_bookjoy_format_to_sql(time) {
        return moment(time, ["HH:mm"]).format('HH:mm:ss');
    },

    time_from_sql_to_bookjoy_format(time) {
        return moment(time, ["HH:mm:ss"]).format('HH:mm');
    },

    convert_datetime_to_bookjoy_time_format(date_time) {
        return moment(date_time, ["YYYY-MM-DD HH:mm:ss"]).format('HH:mm');
    },

    convert_datetime_to_bookjoy_date_time_format(date_time) {
        return moment(date_time, ["YYYY-MM-DD HH:mm:ss"]).format('MMM D, YYYY  hh:mm A');
    },

    time_duration_in_min(start, end) {
        var duration = moment.duration(moment(start, "HH:mm:ss").diff(moment(end, "HH:mm:ss"))).asMinutes();
        duration = duration.toString().replace(/-/g,'');
        return duration;
    },

    comparing_startime_and_endtime(start, end) {
        return moment(start, 'HH:mm:ss').isBefore(moment(end,'HH:mm:ss'));
    },
    
    human_date_format: function (date,timezone,date_format) {
        return moment.utc(date).tz(timezone).format(date_format);
    },

    time_12hrs_format:function(time,time_format){
        return moment(time, 'HH:mm:ss').format(time_format);
    },

    round_to_near_5min:function(time_in_min){
        return (Math.round(time_in_min / 5) * 5);
    },
    

}
export default utils